import { ISavedSearchItem } from "../save-search.types";

/**
 * A very basic validation, just confirming we don't have non-null/empty string props.
 * @param item An item to validate
 * @returns 
 */
const isValidItem = (item: any) => {
  return item.id && item.name && item.url;
}

export const mapSavedSearchList = (result: any): ISavedSearchItem[] => {
  const mappedList: ISavedSearchItem[] = [];
  const savedSearches = result?.savedSearches;
  if (Array.isArray(savedSearches)) {
    savedSearches.forEach((item) => {
      if (isValidItem(item)) {
        mappedList.push({
          id: item.id,
          name: item.name,
          lowerCasedName: String(item.name).toLowerCase(),
          url: item.url
        });
      }
    })
  }
  return mappedList;
};